import { StrategyBuilderFunction, EMPTY_STRATEGY } from 'utils/shared/optionProfitCalculator/types';
import { addLongPut } from 'utils/shared/optionProfitCalculator/addOption';
import {
  getDefaultExpiration,
  findClosestStrikePrice,
  getStrikesAtExpiration,
  expirationToDate,
  getPremium,
  DEFAULT_STOCK_POSITION,
  getStrategyLegStrikeDirection,
  getStrikeDistance,
} from 'utils/shared/optionProfitCalculator/utils';

export const protectivePut: StrategyBuilderFunction = ({
  chain,
  spot,
  expirationDate,
  expirationKey,
  strike,
  strikeDirection,
  contractMultiplier = 1,
}) => {
  // Use the default expiration date function to get the expiration date
  const strikesAtExpiration = expirationKey
    ? getStrikesAtExpiration(chain, expirationKey)
    : getDefaultExpiration(chain);

  if (
    !strikesAtExpiration ||
    !strikesAtExpiration.e ||
    !strikesAtExpiration.ey ||
    !strikesAtExpiration.em ||
    !strikesAtExpiration.ed
  ) {
    return EMPTY_STRATEGY;
  }

  const expirationDateForOptions =
    expirationDate ||
    expirationToDate(strikesAtExpiration.ey, strikesAtExpiration.em, strikesAtExpiration.ed);
  const expirationKeyForOptions = expirationKey || strikesAtExpiration.e;

  // Choose a strike price slightly below the current spot price
  const strikePrice = strike
    ? strike
    : findClosestStrikePrice(strikesAtExpiration, getStrikeDistance({ price: spot, unit: -1 })); // e.g., 2.5% below spot

  if (strikePrice === -1) {
    return EMPTY_STRATEGY;
  }

  // Build the option position
  const optionPosition = addLongPut({
    strike: strikePrice,
    premium: getPremium({
      ask: strikesAtExpiration?.c?.[strikePrice]?.p?.a || 0,
      bid: strikesAtExpiration?.c?.[strikePrice]?.p?.b || 0,
      strikeDirection: getStrategyLegStrikeDirection(strikeDirection, 'long'),
    }),
    expirationDate: expirationDateForOptions,
    expirationKey: expirationKeyForOptions,
    numberOfContracts: 1 * contractMultiplier,
  });

  // Stock position - 100 shares per strategy unit at the current market price
  const stockPosition = {
    price: spot,
    quantity: DEFAULT_STOCK_POSITION * contractMultiplier, // 100 shares per strategy unit
  };

  return {
    optionPositions: [optionPosition],
    stockPositions: [stockPosition],
  };
};
